export default __webpack_public_path__ + "static/media/storage.0af93cff.png";